import AddIcon from '@mui/icons-material/Add';
import { Button, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useRoles from 'common/hooks/useRoles';
import { listManufacturersByPage } from 'store/thunks/manufacturerManagementThunk';
import ManufacturerDialog from './components/ManufacturerDialog';
import ManufacturerManagementFilterButton from './components/ManufacturerManagementFilterButton';
import ManufacturerManagementFilterStatusBar from './components/ManufacturerManagementFilterStatusBar';
import ManufacturerManagementTable from './components/ManufacturerManagementTable';
import RemoveManufacturerDialog from './components/RemoveManufacturerDialog';

// POM-6405 — Inventory → Manufacturer Management. Maintains the pick-list the
// Add Inventory Item dialog offers. Every inventory role can view it
// (viewManufacturerManagement); add, edit and remove need manageManufacturers,
// so Inventory Viewer is read-only.
const ManufacturerManagement = () => {
  const dispatch = useDispatch();
  const hasAccess = useRoles();
  const [addOpen, setAddOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [removing, setRemoving] = useState(null);

  useEffect(() => {
    document.title = 'Manufacturer Management - SmartOS';
    dispatch(listManufacturersByPage({ page: 1 }));
  }, [dispatch]);

  return (
    <>
      <Grid container sx={{ px: 3, pb: 2 }} direction='column'>
        <Grid item container alignItems='center' sx={{ py: 1.5 }}>
          <Grid item sx={{ flexGrow: 1 }}>
            <ManufacturerManagementFilterStatusBar />
          </Grid>
          <Grid item sx={{ display: 'flex', gap: 1 }}>
            {hasAccess.manageManufacturers && (
              <Button variant='contained' startIcon={<AddIcon />} onClick={() => setAddOpen(true)}>
                Add Manufacturer
              </Button>
            )}
            <ManufacturerManagementFilterButton />
          </Grid>
        </Grid>

        <Grid item container sx={{ mt: 1 }}>
          <ManufacturerManagementTable
            onEdit={hasAccess.manageManufacturers ? setEditing : undefined}
            onRemove={hasAccess.manageManufacturers ? setRemoving : undefined}
          />
        </Grid>
      </Grid>

      <ManufacturerDialog open={addOpen} onClose={() => setAddOpen(false)} />
      <ManufacturerDialog
        open={!!editing}
        manufacturer={editing}
        onClose={() => setEditing(null)}
      />
      <RemoveManufacturerDialog
        open={!!removing}
        manufacturer={removing}
        onClose={() => setRemoving(null)}
      />
    </>
  );
};

export default ManufacturerManagement;
